import RelatedEvents from 'components/Section/RelatedEvents'

export default function ProviderEvents({ section }) {
  if (!section.events || section.events.length === 0) {
    return null
  }

  return <RelatedEvents section={section} />
}
